(function () {
    'use strict';

    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {

        $stateProvider.state('commercial-valuation', {
            url: "/:langcode/{path:ticarimin-degeri|value-of-my-commercial|valor-de-mi-comercio|valor-do-meu-comercial}",
            params: {
                path: ['$translate', function ($translate) {
                    return $translate.instant("commercial-valuation");
                }],
                langcode: {
                    value: ['$translate', function ($translate) {
                        return $translate.use();
                    }]
                }
            },
            templateUrl: 'app/valuation-commercial/valuation.html',
            controller: 'NewLandController',
            abstract: true,
            resolve: {
                lazyLoad: ['$transition$', 'lazyLoadSvc', function($transition$, lazyLoadSvc) {
                    return lazyLoadSvc.load($transition$, 'valuationCommercial');
                }],

                translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                    $translatePartialLoader.addPart('endeks_modal');
                    return $translate.refresh();
                }]
            }

        }).state('commercial-valuation.step1', {
            url: "/{path2:ogren|learn|aprender}/:address?top?room?living?bath?area?age?floor?heat?total?tid?nam?e?w?n?s?bosp?city?lake?nature?sea?mn?rd?sp?pl?el?gn?gk?sc?pi?po?si?so?hi?ac?fp?st",
            template: '<commercial-val-step1></commercial-val-step1>',
            params: {
                selectedProducts: null, top: null,
                address: {
                    value: null,
                    squash: true,
                    type: 'any',
                    raw: true
                },
                path2: ['$translate', function ($translate) {
                    return $translate.instant('step1');
                }]
            },
            resolve: {

                LangProtect: ['routeHelpers', function(routeHelpers) {
                    return routeHelpers.langProtectTwoPath();
                }],

                titleStep1: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_title').then(function (res) {
                        return res;
                    });
                }],
                descriptionStep1: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_title').then(function (res) {
                        return res;
                    });
                }],


                translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                    $translatePartialLoader.addPart('valuation_step1');
                    return $translate.refresh();
                }]
            },
            metaTags: {
                title: '{{titleStep1}}',
                robots: [
                    '$transition$',
                    function ($transition$) {
                        if ($transition$.params().address)
                            return 'noindex, nofollow';
                        else
                            return 'index, follow';
                    }
                ],
                description: '{{descriptionStep1}}',
                properties: {
                    'og:image': 'http://www.endeksa.com/share3.jpg',
                    'og:image:secure_url': 'https://www.endeksa.com/share3.jpg',
                    'og:type': 'website'
                }
            }
        }).state('commercial-valuation.step2', {
            url: "/{path2:ozellikler|properties|propiedades|propriedades}",
            template: '<commercial-val-step2></commercial-val-step2>',
            params: {
                selectedProducts: null, top: null,
                path2: ['$translate', function ($translate) {
                    return $translate.instant('step2');
                }]
            },
            resolve: {

                LangProtect: ['routeHelpers', function(routeHelpers) {
                    return routeHelpers.langProtectTwoPath();
                }],

                // guard: ['$rootScope', '$transition$', function ($rootScope, $transition$) {
                //     if ($rootScope.SignedIn)
                //         return true;
                //     else {
                //         $transition$.abort();
                //         $transition$.router.stateService.go('register', { langcode: window.lang });
                //     }
                // }],
                titleStep2: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_title').then(function (res) {
                        return res;
                    });
                }],
                descriptionStep2: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_desc').then(function (res) {
                        return res;
                    });
                }],

                translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                    $translatePartialLoader.addPart('valuation_step2');
                    return $translate.refresh();
                }]
            },
            metaTags: {
                title: '{{titleStep2}}',
                description: '{{descriptionStep2}}',
                robots: 'noindex, nofollow'

            }
        }).state('commercial-valuation.step3', {
            url: "/{path2:ek-ozellikler|additionals|adicionais|complementos}",
            template: '<commercial-val-step3></commercial-val-step3>',
            params: {
                selectedProducts: null, top: null,
                path2: ['$translate', function ($translate) {
                    return $translate.instant('step3');
                }]
            },
            resolve: {

                LangProtect: ['routeHelpers', function(routeHelpers) {
                    return routeHelpers.langProtectTwoPath();
                }],

                titleStep3: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_title').then(function (res) {
                        return res;
                    });
                }],
                descriptionStep3: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_desc').then(function (res) {
                        return res;
                    });
                }],

                translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                    $translatePartialLoader.addPart('valuation_step2');
                    $translatePartialLoader.addPart('valuation_step3');
                    return $translate.refresh();
                }]
            },
            metaTags: {
                title: '{{titleStep3}}',
                description: '{{descriptionStep3}}',
                robots: 'noindex, nofollow'

            }
        }).state('commercial-valuation.step4', {
            url: "/{path2:olanaklar|facilities|instalacoes|instalaciones}",
            template: '<commercial-val-step4></commercial-val-step4>',
            params: {
                selectedProducts: null, top: null,
                path2: ['$translate', function ($translate) {
                    return $translate.instant('step4');
                }]
            },
            resolve: {

                LangProtect: ['routeHelpers', function(routeHelpers) {
                    return routeHelpers.langProtectTwoPath();
                }],

                titleStep4: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_title').then(function (res) {
                        return res;
                    });
                }],
                descriptionStep4: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_desc').then(function (res) {
                        return res;
                    });
                }],

                translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                    $translatePartialLoader.addPart('valuation_step4');
                    $translatePartialLoader.addPart('valuation_step5');
                    return $translate.refresh();
                }]
            },
            metaTags: {
                title: '{{titleStep4}}',
                description: '{{descriptionStep4}}',
                robots: 'noindex, nofollow'

            }
        }).state('commercial-valuation.step5', {
            url: "/{path2:sonuc-tercihi|result-choice|eleccion-de-resultados|escolha-de-resultado}",
            template: '<commercial-val-step5></commercial-val-step5>',
            params: {
                selectedProducts: null, top: null,
                path2: ['$translate', function ($translate) {
                    return $translate.instant('step5');
                }]
            },
            resolve: {

                LangProtect: ['routeHelpers', function(routeHelpers) {
                    return routeHelpers.langProtectTwoPath();
                }],

                titleStep5: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_title').then(function (res) {
                        return res;
                    });
                }],
                descriptionStep5: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_desc').then(function (res) {
                        return res;
                    });
                }],

                translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                    $translatePartialLoader.addPart('valuation_step5');
                    return $translate.refresh();
                }]
            },
            metaTags: {
                title: '{{titleStep5}}',
                description: '{{descriptionStep5}}',
                robots: 'noindex, nofollow'

            }
        });

    }]);

})();
